export enum authorizarionTermType {
  MARKETPLACE = 'marketplace',
  MAGAZINELUIZA = 'magazineluiza',
}
